import b from 'b_';

import { CAPACITY_RESERVE, DEFAULT_CAPACITY, MIN_CAPACITY } from '../paginator.constants';
import { Page, PaginatorPagesProps } from '../types';

export const getMaxScroll = (pagesLength: number, paginatorCapacity: number) =>
    pagesLength - paginatorCapacity + CAPACITY_RESERVE;

export const getSelectedIndex = (pages: Page[]) => pages.findIndex((page) => page.selected);

export const circularShift = <T>(array: T[], shiftIndex: number) => [
    ...array.slice(shiftIndex + 1),
    ...array.slice(0, shiftIndex + 1),
];

export const cnPaginator = b.with('paginator');

export const getCapacityWithDefault = (capacity: number = DEFAULT_CAPACITY) => {
    if (capacity < MIN_CAPACITY) {
        return DEFAULT_CAPACITY;
    }

    return capacity;
};

export const groupPagesAroundActivePage = (pages: PaginatorPagesProps['pages']) => {
    const activeIndex = Math.max(
        0, // активный пункт обязан быть, но подстраховался
        pages.findIndex((page) => page.selected)
    );

    return {
        left: pages.slice(0, activeIndex),
        active: [pages[activeIndex]],
        right: pages.slice(activeIndex + 1),
    };
};
